function LeftArrowIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="16"
      fill="none"
      viewBox="0 0 6 12"
    >
      <path
        fill="#F3953F"
        d="M.645 5.341l4.111-4.197C5.24.65 6 1.052 6 1.804v8.392a.984.984 0 01-.12.475.797.797 0 01-.32.323.654.654 0 01-.42.069.708.708 0 01-.384-.208L.646 6.66a.878.878 0 01-.19-.297 1 1 0 010-.724.878.878 0 01.19-.297H.645z"
      ></path>
    </svg>
  );
}

export default LeftArrowIcon;
